import { getArticleList, getArticle, delArticle } from "../repositories/dataRetrieve";
import { AddArticle, AddPhysicalState, SnackBarMessage } from "../components/index";
import { Add, Category, Delete, Edit, Outbox } from "@mui/icons-material";
import { useFirestorePagination } from "../hooks/useFirestorePagination";
import { useBasicComponentStates } from "../repositories/utils";
import { useNavigate } from "react-router-dom";
import { useEffect, useState, useCallback, useMemo, useRef} from 'react';
import { CircularProgress,
        TableContainer,
        Typography,
        IconButton,
        TableHead,
        TableBody,
        TableCell,
        TableRow,
        Backdrop,
        Divider,
        Button,
        Table,
        Paper,
        Stack,
        Grid,
        Box,
        FormControl,
        OutlinedInput,
        InputLabel,
        InputAdornment,
} from '@mui/material';
import { Search } from "@mui/icons-material";
import PaginationShell  from "../components/PaginationShell";
import { useFirestoreSuggestions } from "../hooks/useFirestoreSuggestions";
import { debounce } from "lodash";

const CommonAdminListPage = () => {
    const paginationDataIE = { total_reg: 0, total_pages: 0, current_page: 0, initial_reg: 0, final_reg: 0,  direction: null, limitRange: 20}

    const {
        loading: mainViewLoading, setLoading: mainViewSetLoading,
        hasLoaded: mainViewHasLoaded, setHasLoaded: mainViewSetHasLoaded
    } = useBasicComponentStates({editingForm: false});

    const {
        hasLoaded: counterHasLoaded, setHasLoaded: counterSetHasLoaded
    } = useBasicComponentStates({editingForm: false});

    const navigate = useNavigate();
	const [showPhysicalCanvas, setShowPhysicalCanvas] = useState(false);
	const [showArticleCanvas, setShowArticleCanvas] = useState(false);
    const [snackSeverity, setSnackSeverity] = useState("success");
	const [selectedArticle, setSelectedArticle] = useState([]);
    const [loadingDelete, setLoadingDelete] = useState(false);
    const [snackMessage, setSnackMessage] = useState("");
    const [productList, setProductList] = useState([]);
    const [snackOpen, setSnackOpen] = useState(false);
    const [paginationData, setPaginationData] = useState(paginationDataIE);
    const [searchValue, setSearchValue] = useState("");
    const [rawInput, setRawInput] = useState("");
    const [inputValue, setInputValue] = useState("");
    const [suggestions, setSuggestions] = useState([]);
    const [suggestionCache, setSuggestionCache] = useState([]);
    const lastFetchRef = useRef("");
    const requestIdRef = useRef(0);

    const {fetchSuggestionFallback} = useFirestoreSuggestions({suggestions, setSuggestions, suggestionCache, setSuggestionCache})

    const { getQueryDoc, getPaginationCount} = useFirestorePagination({searchTerm: searchValue, paginationStates: paginationData, direction: paginationData?.direction, collectionDB: "fragances", orderByElem: "descripcion_corta", limitRange: paginationData.limitRange,})

    const showLoader = (!mainViewHasLoaded && counterHasLoaded === true) || !counterHasLoaded;
    const showEmpty = counterHasLoaded && mainViewHasLoaded && productList.length === 0;
    const showTable = mainViewHasLoaded && productList.length > 0;

    const debouncedSetInput = useMemo(
        () =>
            debounce((value) => {
                setInputValue(value);
            }, 300),
        []
    );

    const executeSearch = useCallback(() => {
        setSuggestions([]);
        mainViewSetHasLoaded(false);
        counterSetHasLoaded(false);

        const newValue = rawInput.trim();

        if (newValue === searchValue){
            mainViewSetHasLoaded(true);
            counterSetHasLoaded(true);
            return;
        }

        requestIdRef.current += 1;

        setPaginationData(prev => ({
            ...paginationDataIE,
            limitRange: prev.limitRange
        }));

        setSearchValue(newValue);
    }, [rawInput, searchValue]);

    const nextPage = async () => {

        mainViewSetHasLoaded(false);
        const newPage = paginationData.current_page + 1;

        setPaginationData(prev => ({
            ...prev,
            current_page: newPage,
            direction: "next"
        }));
    };

    const prevPage = async () => {

        mainViewSetHasLoaded(false);
        if (paginationData.current_page === 0) return;

        const newPage = paginationData.current_page - 1;

        setPaginationData(prev => ({
            ...prev,
            current_page: newPage,
            direction: "prev"
        }));
    };

    const handleCloseArticleCanvas = () => {
		setSelectedArticle([]);
		setShowArticleCanvas(false);
        getProducts();
	};

    const handleClosePhysicalCanvas = () => {
		setShowPhysicalCanvas(false);
	};

    const handleCategories = () => {
		setShowPhysicalCanvas(true);
    };

    const handleArticles = async (pk) => {
		if (pk !== null) {
			const rowData = await getArticle(pk);
			setSelectedArticle(rowData?.data);
		}
		setShowArticleCanvas(true);
    };

    const handleDeleteArticle = async (pk) => {
        setLoadingDelete(true);
        const resp = await delArticle(pk);

        if (resp?.message?.toUpperCase() === "OK") {
            setSnackSeverity("success");
            setSnackMessage("Se eliminó el artículo con éxito.");
            setSnackOpen(true);
            getProducts();
            setLoadingDelete(false);
        } else {
            setSnackSeverity("error");
            setSnackMessage(`Error en la eliminación del artículo seleccionado.`);
            setSnackOpen(true);
            getProducts();
            setLoadingDelete(false);
        };
    };

    const getProducts = async () => { /* solo es para disparar evento tras cambios en lista */
        const currentRequest = requestIdRef.current;

        mainViewSetLoading(true);
        mainViewSetHasLoaded(false);

        if (paginationData.total_reg === 0) {
            setProductList([]);
            mainViewSetHasLoaded(true);
            mainViewSetLoading(false);
            return;
        }

        const queryData = await getQueryDoc();
        const resp = await getArticleList(queryData);

        if (currentRequest !== requestIdRef.current) return;

        const data = resp?.data ?? [];

        setProductList(data);

        const docsLength = data.length;
        const currentPage = paginationData.current_page;

        const initialItem = currentPage * paginationData.limitRange + 1;

        const finalItem = Math.min(
            initialItem + docsLength - 1,
            paginationData.total_reg
        );

        setPaginationData(prev => ({
            ...prev,
            initial_reg: initialItem,
            final_reg: finalItem
        }));

        mainViewSetHasLoaded(true);
        mainViewSetLoading(false);
    };

    // obtiene  sugerencias locales (segunda capa, cero consumo.)
    useEffect(() => {
    const saved = localStorage.getItem("fraganceSuggestions");

        if (saved) {
            const parsed = JSON.parse(saved);

            const clean = parsed.filter(item => typeof item === "string");

            setSuggestionCache(clean);
        }
    }, []);

    // alimentacion de sugerencias por cache de react y local storage (primera y segunda capa, consumo propio de la app)
    useEffect(() => {
        if (productList.length === 0) return;

        const newSuggestions = [];

        productList.forEach(p => {
            if (typeof p.descripcion_corta === "string")
                newSuggestions.push(p.descripcion_corta);

            if (typeof p.marca === "string")
                newSuggestions.push(p.marca);

            if (typeof p.linea === "string")
                newSuggestions.push(p.linea);
        });

        const merged = [...new Set([...suggestionCache, ...newSuggestions])];

        setSuggestionCache(merged);

        localStorage.setItem(
            "fraganceSuggestions",
            JSON.stringify(merged)
        );

    }, [productList]);

    useEffect(() => {
        if (rawInput.length < 2) {
            setInputValue("");
            return;
        }

        const handler = setTimeout(() => {
            setInputValue(rawInput);
        }, 300);

        return () => clearTimeout(handler);
    }, [rawInput]);

    useEffect(() => {
        if (inputValue.length < 2) {
            setSuggestions([]);
            return;
        }

        const normalized = inputValue.toUpperCase();

        const filtered = suggestionCache
        .filter(item =>
            item.toUpperCase().includes(normalized)
        )
        .slice(0, 6);

        if (filtered.length > 0) {
            setSuggestions(filtered);
            return;
        }

        if (lastFetchRef.current !== normalized) {
            lastFetchRef.current = normalized;
            fetchSuggestionFallback(normalized);
        }

    }, [inputValue, suggestionCache]);

    useEffect(() => {
        if (!counterHasLoaded) return;

        const currentRequest = requestIdRef.current;

        const loadProducts = async () => {
            mainViewSetLoading(true);
            mainViewSetHasLoaded(false);

            if (paginationData.total_reg === 0) {
                setProductList([]);
                mainViewSetHasLoaded(true);
                mainViewSetLoading(false);
                return;
            }

            const queryData = await getQueryDoc();
            const resp = await getArticleList(queryData);

            if (currentRequest !== requestIdRef.current) return;

            const data = resp?.data ?? [];

            setProductList(data);

            const docsLength = data.length;
            const currentPage = paginationData.current_page;

            const initialItem = currentPage * paginationData.limitRange + 1;

            const finalItem = Math.min(
                initialItem + docsLength - 1,
                paginationData.total_reg
            );

            setPaginationData(prev => ({
                ...prev,
                initial_reg: initialItem,
                final_reg: finalItem
            }));

            mainViewSetHasLoaded(true);
            mainViewSetLoading(false);
        };

        loadProducts();

    }, [
        counterHasLoaded,
        paginationData.current_page,
        paginationData.direction,
        paginationData.total_reg,
        searchValue
    ]);

    useEffect(() => {
        const currentRequest = requestIdRef.current;

        const loadCount = async () => {
            mainViewSetLoading(true)

            const queryCount = await getPaginationCount();

            if (currentRequest !== requestIdRef.current) return;

            setPaginationData(prev => ({
                ...prev,
                total_reg: queryCount.total_reg,
                total_pages: queryCount.total_pages,
                current_page: 0
            }));

            counterSetHasLoaded(true);
        };
        loadCount();
    }, [searchValue]);

    useEffect(() => {
        return () => {
            debouncedSetInput.cancel();
        };
    }, [debouncedSetInput]);

    return (
        <>
            <Grid item xs={6}>
                <FormControl size="small" variant="outlined" sx={{ minWidth: "80%", marginTop: "2vh", marginLeft: "10vw"}}>
                    <InputLabel>{searchValue ? `Busqueda de "${searchValue}"` : "Busqueda por descripción, marca o modelo"}</InputLabel>
                    <OutlinedInput
                        size="small"
                        value={rawInput}
                        onChange={(e) => {
                            setRawInput(e.target.value)
                        }}
                        onKeyDown = {(e) => {
                            if (e.key === "Enter") {
                                executeSearch()
                            }
                        }}
                        label="Busqueda por descripción, marca o modelo"
                        endAdornment={
                            <InputAdornment position="end" sx={{ display: "flex", alignItems: "center", height: "100%" }}>
                                <Divider
                                    orientation="vertical"
                                    flexItem
                                    sx={{ alignSelf: "stretch", mr: "5px", bgcolor: "#007FC4", width: "1px" }}
                                />
                                <IconButton
                                    sx={{
                                        padding: "7px",
                                        color: "#007FC4",
                                        mr: "5px",
                                        "&:hover": {
                                            color: "#FFFFFF",
                                            bgcolor: "#007FC4",
                                        },
                                    }}
                                    onClick={() => {
                                        executeSearch()
                                    }}
                                >
                                    <Search sx={{ fontSize: 18, color: "inherit" }} />
                                </IconButton>
                            </InputAdornment>
                        }
                        sx={{
                            padding: 0,
                            borderRadius: "3px",
                        }}
                    />
                    {suggestions.length > 0 && (
                        <FormControl sx={{ position: "relative"}}>
                            <Paper
                                sx={{
                                    position: "absolute",
                                    top: "100%",
                                    width: "100%",
                                    zIndex: 20
                                }}
                            >
                                {suggestions.map((s, i) => (
                                    <Box
                                        key={i}
                                        sx={{
                                            padding: "8px",
                                            cursor: "pointer",
                                            "&:hover": {
                                                backgroundColor: "#f5f5f5"
                                            }
                                        }}
                                        onClick={() => {
                                            setRawInput(s);
                                            setInputValue(s);
                                            setSearchValue(s);
                                            setSuggestions([]);
                                        }}
                                    >
                                        {s}
                                    </Box>
                                ))}
                            </Paper>
                        </FormControl>
                    )}
                </FormControl>
            </Grid>
            <Box
                sx={{
                    backgroundColor: 'rgba(217, 217, 217, 0.5)',
                    margin: 'auto',
                    marginTop: {xs: '2vh'},
                    marginBottom: {xs: '2vh'},
                    height: {xs: '85vh', md:'70vh'},
                    width: {xs: '90vw', md:'75vw'},
                    borderRadius: '20px',
                    overflowY: 'auto'
                }}
            >
                {/* Comportamiento pc */}
                <Box sx={{ display: { xs: 'none', md: "flex" } }}>
                    <Typography
                        width='60%'
                        variant="h3"
                        component="div"
                        sx={{
                            justifyContent: 'left',
                            color: 'dimgray',
                            fontFamily: 'Barlow',
                            margin: '1rem'
                        }}
                    >
                        Artículos registrados
                    </Typography>

                    <Stack
                        width='40%'
                        direction="row"
                        spacing={1}
                        justifyContent='end'
                        marginRight='2rem'
                        sx={{
                            maxHeight: '2rem',
                            display: 'flex',
                            alignSelf: 'center'
                        }}
                    >
                        <Button variant="contained" size="small" color="warning" startIcon={<Category />} onClick={() => handleCategories()}>
                            Categorias
                        </Button>
                        <Button variant="contained" size="small" color="info" startIcon={<Add />} onClick={() => handleArticles()}>
                            Registrar
                        </Button>
                    </Stack>
                </Box>

                {/* Comportamiento moviles */}
                <Box sx={{ display: { xs: 'flex', md: "none" } }}>
                    <Typography
                        width='85%'
                        variant="h5"
                        component="div"
                        sx={{
                            justifyContent: 'left',
                            color: 'dimgray',
                            fontFamily: 'Barlow',
                            margin: '1rem'
                        }}
                    >
                        Artículos registrados
                    </Typography>

                    <Stack
                        width='15%'
                        direction="row"
                        spacing={1}
                        justifyContent='end'
                        marginRight='1rem'
                        sx={{
                            maxHeight: '2rem',
                            display: 'flex',
                            alignSelf: 'center'
                        }}
                    >
                        <IconButton aria-label="category" size="small" onClick={() => handleCategories()} >
                            <Category fontSize="inherit" color="warning" />
                        </IconButton>
                        <IconButton aria-label="add" size="small" onClick={() => handleArticles()} >
                            <Add fontSize="inherit" color="info" />
                        </IconButton>
                    </Stack>
                </Box>

                <Divider sx={{ border: '1px #000 solid', width: '90%', justifySelf: 'center', marginBottom: { xs: "2rem", md: "3rem"} }} />

                {showLoader &&
                    <Typography
                        variant="h2"
                        component="div"
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            color: 'dimgray',
                            fontFamily: 'Barlow',
                            height: '70vh',
                            placeItems: 'center'
                        }}
                    >
                        <CircularProgress sx={{ width: "70px !important", height: "70px !important", color: "#62C21B" }} />
                    </Typography>
                }
                {showEmpty &&
                    <Typography
                        variant="h2"
                        component="div"
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            color: 'dimgray',
                            fontFamily: 'Barlow',
                            height: '70vh',
                            placeItems: 'center'
                        }}
                    >
                        Sin productos registrados
                    </Typography>
                }
                {showTable &&
                    <Box
                        sx={{
                            width: {xs: '90%', md: '96%'},
                            margin: {xs: '5%', md: '2%'},
                            rowGap: 2,
                            gap: 2,
                        }}
                    >
                        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                            <TableContainer sx={{ maxHeight: { xs: '70vh', md: "60vh" } }}>
                                <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                        <TableRow key="head-titles">
                                            <TableCell align="center">#</TableCell>
                                            <TableCell align="center">Descripción</TableCell>
                                            <TableCell align="center">Referencia</TableCell>
                                            <TableCell align="center">SKU</TableCell>
                                            <TableCell align="center">Descuento</TableCell>
                                            <TableCell align="center">Acciones</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {productList.map((row, index) => (
                                            <TableRow key={row.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell component="th" scope="row" align="center"> {index + (paginationData.limitRange * paginationData.current_page) + 1} </TableCell>
                                                <TableCell align="left"> {row.descripcion_corta} </TableCell>
                                                <TableCell align="center"> {row.referencia} </TableCell>
                                                <TableCell align="center"> {row.sku} </TableCell>
                                                <TableCell align="center">
                                                    {row.descuento}
                                                </TableCell>
                                                <TableCell>
                                                    <Stack direction="row" spacing={1} sx={{ display: 'flex', justifySelf: 'center' }}>
                                                        <IconButton title="Editar" aria-label="edit" size="small" onClick={() => handleArticles(row.uuid)} >
                                                            <Edit fontSize="inherit" color="warning" />
                                                        </IconButton>
                                                        <IconButton title="Vista previa" aria-label="preview" size="small" onClick={() => navigate("/adminDetail", { state: { productId: row?.uuid } })} >
                                                            <Outbox fontSize="inherit" color="info" />
                                                        </IconButton>
                                                        <IconButton title="Eliminar" aria-label="delete" size="small" onClick={() => handleDeleteArticle(row?.uuid)} >
                                                            <Delete fontSize="inherit" color="error" />
                                                        </IconButton>
                                                    </Stack>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>
                    </Box>
                }
                <Backdrop
                    sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
                    open={loadingDelete}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
                <AddPhysicalState showOffCanvas={showPhysicalCanvas} handleCloseOffCanvas={handleClosePhysicalCanvas} />
                <AddArticle showOffCanvas={showArticleCanvas} data={selectedArticle} handleCloseOffCanvas={handleCloseArticleCanvas} />
                <SnackBarMessage severity={snackSeverity} message={snackMessage} open={snackOpen} hideDuration={1500} onClose={() => setSnackOpen(false)} />
            </Box>
            {/* Paginador de tabal de usuarios */}
            <Grid container sx={{flexGrow: 1}}>
                <Grid item xs={12} sx={{ display: "flex", justifyContent: "end", alignItems: "start", pb:"10px"}}>
                    <PaginationShell
                        currentPage={paginationData?.current_page}
                        initialItem={paginationData?.initial_reg}
                        totalPage={paginationData?.total_pages}
                        totalItems={paginationData?.total_reg}
                        finalItem={paginationData?.final_reg}
                        nextFunction={nextPage}
                        prevFunction={prevPage}
                        loadingState={mainViewLoading}
                    />
                </Grid>
            </Grid>
        </>
    )
}

export default CommonAdminListPage;
